import PropTypes from "prop-types";
import { useState } from "react";
import { Collapse, Icon } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

// Argon components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

function SidenavCollapse({ icon, name, children, active = false }) {
  const [open, setOpen] = useState(active);

  const handleClick = () => setOpen(!open);

  return (
    <>
      <ArgonBox
        display="flex"
        alignItems="center"
        px={2}
        py={1.5}
        sx={{
          cursor: "pointer",
          userSelect: "none",
          transition: "background-color 0.3s ease",
          "&:hover": {
            backgroundColor: "#f0f2f5",
          },
        }}
        onClick={handleClick}
      >
        <ArgonBox mr={2}>{icon}</ArgonBox>
        <ArgonTypography variant="button" fontWeight="medium" textTransform="capitalize">
          {name}
        </ArgonTypography>
        <ArgonBox ml="auto">
          {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
        </ArgonBox>
      </ArgonBox>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <ArgonBox pl={4}>{children}</ArgonBox>
      </Collapse>
    </>
  );
}

SidenavCollapse.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  active: PropTypes.bool,
};


export default SidenavCollapse;
